import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const scrollToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const Footer = ({ user }) => {
  if (user) {
    return (
      <footer className="footer footer--logged-in">
        <div className="footer-container">
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} PayCIS. All rights reserved.</p>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>PayCIS</h3>
            <p>Making CIS payments easy for construction contractors.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
              <li><Link to="/cis-calculator" onClick={scrollToTop}>CIS Calculator</Link></li>
              <li><Link to="/learn-more" onClick={scrollToTop}>Learn More</Link></li>
              <li><Link to="/login" onClick={scrollToTop}>Login</Link></li>
              <li><Link to="/register" onClick={scrollToTop}>Register</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" onClick={scrollToTop}>Terms and Conditions</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact & Social</h4>
            <ul>
              <li><Link to="/contact" onClick={scrollToTop}>Contact Us</Link></li>
              <li>
                <a 
                  href="https://www.facebook.com/paycis/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link facebook-link"
                >
                  <svg className="facebook-icon" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Facebook
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} PayCIS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;